import { createRouterLinks } from "@/models/router";
import { RouteConfig } from "vue-router";
import { RExpertServices } from "@/modules/Services/RServices";
import { RExpertGuide } from "./views/Guide/RExpertGuide";
import { RExpertCompanies } from "@/pages/Layout/views/Expert/views/Companies/RExpertCompanies";
import { RExpertInvites } from "@/pages/Layout/views/Expert/views/Invites/RExpertInvites";
import { RExpertEmployees } from "@/pages/Layout/views/Expert/views/Employees/RExpertEmployees";

export const RExpert: RouteConfig = {
  path: "expert",
  component: () =>
    import(
      /* webpackChunkName: "expert" */
      "./VExpert.vue"
    ),
  children: [
    {
      path: "",
      redirect: RExpertServices.path,
    },
    RExpertServices,
    RExpertCompanies,
    RExpertEmployees,
    RExpertGuide,
    RExpertInvites,
  ],
};

export const expertLinks = createRouterLinks(RExpert);
